<script>
export default {
  props: {
    moduleName: String,
    value: {
      type: Boolean,
    },
  },
  computed: {
    isArchiveFeedback: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
  },
};
</script>

<template>
  <div>
    <div
      class="text-h6 text-sm-h4 my-4 d-flex justify-space-between align-center"
    >
      Отзывы {{ moduleName }}
    </div>
    <v-chip-group
      v-model="isArchiveFeedback"
      active-class="primary accent-4 white--text"
      column
    >
      <v-chip color="white" :value="false">
        <v-icon>mdi-check</v-icon>
        Активные
      </v-chip>
      <v-chip color="white" :value="true">
        <v-icon>mdi-archive</v-icon>
        Архивные
      </v-chip>
    </v-chip-group>
  </div>
</template>
